import { defineComponent as _defineComponent } from 'vue'
import type { ClassicModuleFragment } from '@/features/onboarded-home/types';

import HorizontalTitleList from '@/components/timeline/HorizontalTitleList.vue';
import StreamingChartListItem from '@/features/onboarded-home/components/modules/streaming-chart/StreamingChartListItem.vue';

import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';
import { useMediaQuery } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassicModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null,
    showPosition: { type: Boolean },
    verticalLayoutOnMobile: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	moduleData: ClassicModuleFragment;
	globalPosition: number;
	localPosition?: number;
	showPosition?: boolean;
	verticalLayoutOnMobile?: boolean;
};



useProvideClickoutPlacement(() => (props.showPosition ? 'discovery_top_10_module' : 'discovery_classic_module'));

const isMobileViewport = useMediaQuery('(max-width: 767px)');

/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
	titleSize: () => props.moduleData?.titles?.length,
});

function trackTitleClicked(...contextData: Parameters<typeof SnowplowTitleContextGraphql.fromTitle>) {
	trackHomeModule('titleClicked', {
		spec: { label: moduleContext.value.type },
		contexts: [SnowplowTitleContextGraphql.fromTitle(...contextData)],
	});
}

return { __sfc: true,props, isMobileViewport, moduleContext, moduleObserveVisibility, trackHomeModule, trackTitleClicked, HorizontalTitleList, StreamingChartListItem }
}

})